import {AdvancedFilter} from "@/poster-gallery/classes/advanced-filters/advanced-filter";
export class AnimationFilter extends AdvancedFilter {
    static advancedFiltersArrayKey = 'animation';

    showAllOptions() {
        this.getFilterTypeButtonContainer().removeClass('_hidden');
    }

    hideAllOptions() {
        this.getFilterTypeButtonContainer().addClass('_hidden');
    }
}